interface Scripts {
  name: string;
  src: string;
}
export const ScriptStore: Scripts[] = [{ name: '2checkout', src: 'https://www.2checkout.com/checkout/api/2co.min.js' }];
